import styled from 'styled-components';

export const SitePageHeaderContainer = styled.header`
  padding-bottom: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 1em;
`;
